<template>
    <div>
        <DCard
            :title="$t('roles.index_title')"
            padding
        >
            <DTable
                :fields="[
                    {key: 'id', label: $t('roles.table_id')},
                    {key: 'name', label: $t('roles.table_name')},
                    {key: 'actions', label: ''}
                ]"
                :items="roles"
            >
                <template #actions="{item}">
                    <td class="width">
                        <div class="actions">
                            <DButton
                                icon="pencil"
                                mini
                                @click="editPage(item)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>
        </DCard>

        <DFabs>
            <DFab
                icon="plus"
                :label="$t('common.create')"
                @click="createPage"
            />
        </DFabs>
    </div>
</template>

<script>
import { router } from '@inertiajs/vue3'

export default {
    name: 'RoleIndex',
    components: {
    },
    props: {
        roles: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            modalVisible: false
        }
    },
    methods: {
        editPage (item) {
            router.get(this.$route('roles.edit', { role: item.id }))
        },
        createPage () {
            router.get(this.$route('roles.create'))
        }
    }
}
</script>

<style>
    .width {
        width: 150px
    }
    .actions {
        display: flex; grid-gap: 10px
    }
</style>
